export default "__VITE_ASSET__64304ea5__"